import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
    addToCart(cartItems) {
      return apiClient.put('/cartItems', cartItems)
    },
    removeFromCart(cartItemId) {
      return apiClient.delete('/cartItem/' + cartItemId)
    },
    getFromCart() {
      return apiClient.get(`/carts`)
    },
    updateStock(cartItems) {
      return apiClient.post(`/stockUpdate?cart_id=${cartItems[0]['cart_id']}`, cartItems)
    },
    checkStock(unitId, productId, quantityToCheck) {
      return apiClient.get(`/untiStore/${unitId}/product/${productId}/stockCheck/${quantityToCheck}`)
    }
}